import {AlertListItem} from './types';
import {getUsername} from '../../../_shared/GWTBridge/invoke/genPage';
import {texts} from '../texts';

export const alertListFilter = (item: AlertListItem, searchString: string) => {
    return Object.keys(item).some(field => {
        const value = item[field];

        if (typeof value === 'string') {
            return value.toLowerCase().includes(searchString);
        } else if (field === 'alertNumber') {
            return `${value}`.includes(searchString);
        } else if (field === 'conditions') {
            return item.conditions.some(condition => {
                return Object.values(condition).some(
                    fieldValue =>
                        fieldValue && fieldValue.toLocaleLowerCase().includes(searchString)
                );
            });
        } else if (field === 'autofillData' && item.autofillData) {
            return Object.values(item.autofillData).some(field => {
                return field.toLowerCase().includes(searchString);
            });
        }
        return false;
    });
};

export const updateIsActiveRule = (rule, updatedRule) => {
    if (rule.alertNumber === updatedRule.ruleNumber) {
        return {...rule, isActive: updatedRule.isActive};
    }
    return rule;
};

export const isRuleAppliedToCurrentUser = (ruleUsers: string, filterUser: string) => {
    const currentUser = getUsername().toLowerCase();
    const myself = texts.myself_label.toLowerCase();

    return ruleUsers.split(', ').some(validUser => {
        return (
            validUser === filterUser ||
            (validUser === currentUser && filterUser === myself) ||
            (validUser === myself && filterUser === currentUser)
        );
    });
};
